export interface Language {
  getAppLanguage: () => string;
  checkAppLanguage: () => boolean;
}

export enum Languages {
  Ru = 'ru',
  En = 'en',
}
